var _defs, _rect, _rect2, _text, _rect3, _text2, _rect4, _text3, _rect5, _text4, _rect6, _text5, _rect7, _text6, _rect8, _text7, _rect9, _text8, _rect10, _text9, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _br, _text10, _rect24, _br2, _text11, _switch;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMap5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "241px",
    height: "401px",
    viewBox: "-0.5 -0.5 241 401",
    content: "<mxfile host=\"app.diagrams.net\" modified=\"2023-02-12T05:31:08.314Z\" agent=\"5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/109.0.0.0 Safari/537.36\" etag=\"sOFKZ_AlI3qbAtHPnQRI\" version=\"20.5.3\" type=\"device\"><diagram id=\"9p4TfJscrcLIHBW24Trj\" name=\"\\u30DA\\u30FC\\u30B81\">5Zpdb5swFIZ/jS8rgY3BXEJK211U6lpN064mCk5gIzgjzkf362eCCRC7VaqWQtlNdHhtbPP42Mc5ANBsub8uwlVyy2KaAWjEe4AuAYQOgeK3FJ4qwUJ2JSyKNK4ksxEe0r9UioZUN2lM152KnLGMp6uuGLE8pxHvaGFRsF232pxl3V5X4YIqwkMUZqr6PY15UqkEOo1+Q9NFUvds2m5VsgzryvJJ1kkYs11LQgFAs4IxXlnL/YxmJbuaS3Xf1TOlx4EVNOfn3ID579tfPy//0NDeLldbHBro5sK0qma2YbaRTyxHy59qBAXb5DEtWzEA8ndJyunDKozK0p2Yc6ElfJmJK1OY6qjkQLe04HTfkuQorylbUl48iSqyFBJJTLqMacvrXTMB0JJa0oJvGVIM5aQvjm03XIQh0bwGE1YwYRMENnAxcF0QYOAFwLMGR3ck8AI6E2rQmf2hs1V08BOggyNA56jo0CdAh0aAjijo1nwTl88YIEAQcH1p+DNpeP7oQFojAOmqASJwgesBEpSuKDzQx4ODOw0ZlnsmOKcvbnVnHW7CzyDwSO1wteeVa7ntixD4V40yOrZYZUu00bgvtOZk0ZpDo4UatCLMYOAfAo8YjOdIfoTU1K2G+tiIInQeUdIbUc0BO3CAawHf+ZRE4ZnLvz+i6qnobZDmLOfyjycqL9Msm7GMFYem0JxENIqEvuYF+01bJY8El3thT5EfqwFMQxn2RRlp4tf0KGt2h4+lrAllk6OMnKEpo/+B8uC+/N6ppDFShoP7spqJmh5lc3DKatJqepTh4DvGFE9yCJ9Q1uVwPpSyJoMzOcrIGphy3f+kKVtwaMpTPC8rlIfeMSw4RcrOCWVNilifWn875evt7uqHcZfkdHEX3W+/fDO+3l/ospgY+D4gHoB2Jrr3HwthLUoLBBbwCSBvfEfRJZyznB7hKiQ1vJ+HW6crXkgSIZ0L18fZd6ercWGZ/8WnL35cVBe5OvBVRu5o2PXt6L0Tyu1lEdN5uDkMpa8pg6Q7ZSZRp0yX18OvXw/isvnM4VDW+lYEBf8A</diagram></mxfile>",
    style: {
      backgroundColor: "rgb(255, 255, 255)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 240,
    height: 400,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 0,
    width: 120,
    height: 100,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 50,
      marginLeft: 121
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "51\u6559\u5BA4")))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 54,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "51\u6559\u5BA4")))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 100,
    width: 120,
    height: 100,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 150,
      marginLeft: 121
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "52\u6559\u5BA4")))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 154,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "52\u6559\u5BA4")))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 200,
    width: 120,
    height: 100,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 250,
      marginLeft: 121
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "53\u6559\u5BA4")))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 254,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "53\u6559\u5BA4")))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 300,
    width: 120,
    height: 100,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 350,
      marginLeft: 121
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "student\u30DB\u30FC\u30EB")))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 354,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "student\u30DB\u30FC\u30EB")))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 330,
    width: 120,
    height: 70,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 365,
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "\u968E\u6BB5")))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 369,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "\u968E\u6BB5")))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 290,
    width: 80,
    height: 40,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 310,
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "\u30A8\u30EC\u30D9\u30FC\u30BF\u30FC")))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 314,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "\u30A8\u30EC\u30D9\u30FC\u30BF\u30FC")))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 250,
    width: 80,
    height: 40,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 270,
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "\u30A8\u30EC\u30D9\u30FC\u30BF\u30FC")))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 274,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "\u30A8\u30EC\u30D9\u30FC\u30BF\u30FC")))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 170,
    width: 80,
    height: 80,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 210,
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "\u5973\u6027\u30C8\u30A4\u30EC")))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 214,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "\u5973\u6027\u30C8\u30A4\u30EC")))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 90,
    width: 80,
    height: 80,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 130,
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "\u7537\u6027\u30C8\u30A4\u30EC")))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 134,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "\u7537\u6027\u30C8\u30A4\u30EC")))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 305,
    width: 10,
    height: 20,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 270,
    width: 10,
    height: 20,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 210,
    width: 10,
    height: 20,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 170,
    width: 10,
    height: 20,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 110,
    width: 10,
    height: 20,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 10,
    width: 10,
    height: 20,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 70,
    width: 10,
    height: 20,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 100,
    width: 10,
    height: 20,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 180,
    width: 10,
    height: 20,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 260,
    width: 10,
    height: 20,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 300,
    width: 10,
    height: 20,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 330,
    width: 20,
    height: 10,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 90,
    width: 30,
    height: 235,
    fill: "rgb(255, 255, 255)",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 28,
      height: 1,
      paddingTop: 208,
      marginLeft: 86
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "\u5ECA", _br || (_br = /*#__PURE__*/React.createElement("br", null)), "\u4E0B")))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 211,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "\u5ECA&#xa;\u4E0B")))), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 20,
    width: 80,
    height: 50,
    fill: "rgb(255, 255, 255)",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 45,
      marginLeft: 6
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "\u30B5\u30FC\u30D3\u30B9", _br2 || (_br2 = /*#__PURE__*/React.createElement("br", null)), "\u30AB\u30A6\u30F3\u30BF\u30FC")))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 45,
    y: 49,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "\u30B5\u30FC\u30D3\u30B9&#xa;\u30AB\u30A6\u30F3\u30BF\u30FC"))))), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }), /*#__PURE__*/React.createElement("a", {
    transform: "translate(0,-5)",
    xlinkHref: "https://www.diagrams.net/doc/faq/svg-export-text-problems",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fontSize: "10px",
    x: "50%",
    y: "100%"
  }, "Text is not SVG - cannot display")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap5);
export default __webpack_public_path__ + "static/media/map_5.e97a1d1d4b00f1c66cc58ff44407cc18.svg";
export { ForwardRef as ReactComponent };